import { z } from 'zod';

export const AuthorNoteSchema = z.object({
  createdAt: z.coerce.date().optional(),
  createdBy: z.string().optional(),
  text: z.string().optional()
});

export type AuthorNote = z.infer<typeof AuthorNoteSchema>;